export enum MonographSalesCatalogueItemType {
    Test = 'Test',
    Package = 'Package'
}
